import Vue from "vue";
import VueCookies from "vue-cookies";

import { LocalizationPlugin } from "@/plugins/localization";
import { AxiosPlugin } from "@/plugins/axios";

Vue.use(VueCookies);
Vue.use(LocalizationPlugin);
Vue.use(AxiosPlugin);
const v = new Vue();
export default {
  //@ts-ignore
  array_to_select: (state) => (payload) => {
    //@ts-ignore
    return payload.map((el) => {
      return {
        //@ts-ignore
        name: v.$t(el),
        value: el,
      };
    });
  },
};
